module.exports = __webpack_public_path__ + "static/media/campaign-thumbnail-phishing.efbda8e5.png";